import { Injectable } from '@angular/core';

export type Language = 'Korean' | 'English' | 'Vietnamese' | 'Thai' | 'Chinese';
// 한국어, 영어, 중국어(LH), 베트남어, 태국어
@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private Korean = {
    Title: {
      Title: '스마트안전 TBM'
    },
    login: {
      hello: '반갑습니다.',
      description: '앞으로 스마트안전 TBM에서 편리하고\n안전하게 근무하세요!',
      id: '아이디',
      password: '비밀번호',
      auto: '자동로그인',
      login: '로그인',
      signup: '회원가입',
      findId: '아이디 찾기',
      findPassword: '비밀번호 찾기'
    },
    loginWait: {
      done: '회원가입 신청이 완료되었습니다!',
      info: '사업주께서 승인하면 회원가입이 완료됩니다.',
      wait: '회원가입 신청이 대기중입니다. 자세한 내용은 사업주에게 문의하세요.',
      ok: '확인',
      loginWait: '회원가입 신청 대기중입니다.',
      question: '자세한 내용은 사업주에게 문의하세요.'
    },
    signup: {
      signup: '회원가입',
      type: '어떤 회원으로 가입하시나요?',
      worker: '근로자',
      partner: '사업주',
    },
    selectCompany: {
      selectCompany: '업체를 선택해주세요',
      search: '업체 검색',
      searchCompany: '업체를 검색해주세요'
    },
    companyResult: {
      ceo: '대표',
      businessNo: '사업자등록번호',
      findCompany: '검색한 업체를 찾았습니다',
      next: '다음'
    },
    workerSignup: {
      workerSignup: '근로자 회원가입',
      registerInfo: '정보를 등록해주세요'
    },
    category: {
      id: '아이디',
      password: '비밀번호',
      passwordCheck: '비밀번호 확인',
      name: '이름',
      phoneNumber: '휴대폰번호',
      nohyphen: '- 없이 입력',
      check: '인증',
      birthday: '생년월일',
      nation: '국적',
      select: '선택',
      bizType: '업종',
      Type1: '제조',
      Type2: '유통',
      Type3: '서비스',
      jobType: '직종',
      man: '남',
      woman: '여',
      experience: '경력',
      adexperience: '경력 추가',
      certificate: '자격증',
      adcertificate: '자격증 추가',
      selectFive: '최대 5개까지 추가 가능',
      agree: '스마트안전 TBM 개인정보처리방침에 동의합니다.',
      personalPolicy: '개인정보처리방침',
      policyAgree: '스마트안전 TBM 서비스 이용약관에 동의합니다.',
      policy: '서비스 이용약관', 
      sign: '전자서명',
      clickSign: '클릭해서 서명 해주세요.'
    },
    guide: {
      image: '프로필 이미지를 선택해주세요.(선택사항)',
      imageSelect: '이미지 선택',
      album: '앨범',
      camera: '카메라',
      inputID: '아이디를 입력해주세요.',
      idLeastLetters: '아이디를 3자이상 작성해주세요.',
      idDouble: '아이디가 중복되었습니다.',
      OKid: '사용 가능한 아이디입니다.',
      inputPassword: '비밀번호를 입력해주세요.',
      leastLetters: '비밀번호를 6자 이상 입력해주세요.',
      checkPassword: '비밀번호 확인을 입력해주세요.',
      incorrectPass: '입력한 비밀번호가 일치하지 않습니다.',
      inputName: '이름을 입력해주세요',
      inputPhone: '휴대폰번호를 입력해주세요',
      receiveCheck: '인증번호\n받기',
      OKcheck: '인증번호\n확인',
      phoneNo: '사용할 수 없는 전화번호 형식입니다.',
      phoneDouble: '휴대폰번호가 중복되었습니다.',
      inputCheck: '인증번호를 입력해주세요',
      sendCheck: '인증번호를 전송중입니다.',
      phoneCheck: '휴대폰 인증을 해주세요.',
      checked: '인증 되었습니다.',
      inputBirthday: '생년월일을 입력해주세요.',
      selectNation: '국적을 선택해주세요.',
      bizTypeSelect: '업종을 선택해주세요.',
      jobTypeSelect: '직종을 선택해주세요.',
      experiSelect: '경력을 입력해주세요.(선택사항)',
      certifiSelect: '자격증을 추가해주세요.(선택사항)',
      plzPersonAgree: '개인정보처리방침에 동의해주세요.',
      plzPolicyAgree: '마케팅처리방침에 동의해주세요.',
      plzSign: '서명을 해주세요.',
      okSign: '회원가입'
    },
    BizSignup: {
      BizSignup: '사업주 회원가입',
      position: '직책',
      inputPosition: '직책을 입력해주세요.(20자)'
    },
    toastPopup: {
      okSignup: '회원가입 완료',
      didSignup: '회원가입 되었습니다.'
    },
    loading: {
      hello1: '안녕하세요',
      sir: '님,',
      nicemeet: '반갑습니다.'
    },
    workerHome: {
      startTBM: '금일 작업 TBM을 시작해주세요.',
      menu: '메뉴',
      workHistory: '작업이력',
      appNoti: '공지사항',
      Ealam: '긴급알림',
      TBMNoti: 'TBM 공지사항'
    },
    logout: {
      wantLogout: '로그아웃 하시겠습니까?',
      cancel: '취소',
      logout: '로그아웃'
    },
    nfc: {
      nfc: 'NFC 스캔',
      doNfcTag: 'NFC 카드를 가까이에 태깅해주세요.'
    },
    qr: {
      doQR: 'QR 코드를 스캔해주세요.',
      qr: 'QR 스캔'
    },
    tagPopup: {
      startWork: '금일 작업을 시작합니다.'
    },
    aftertagging: {
      TBMList: '금일 TBM 확인 목록이에요.',
      workBegin: '모두 확인하시면, 작업이 시작됩니다.',
      notiCheck: '공지사항 확인하기',
      eduCheck: '안전보건교육 확인하기',
      dangerCheck: '위험요인 확인하기'
    },
    noticheck: {
      TBMNotiCheck: 'TBM 공지사항 확인',
      title: '제목',
      writer: '작성자',
      contents: '내용',
      attachment: '첨부파일',
      next: '다음',
      gotItNoti: '모든 공지사항을 확인하고, 숙지하였습니다.',
      doSign: '서명합니다.'
    },
    educationCheck: {
      educationCheck: '안전보건교육 확인하기',
      TBMedu: 'TBM 안전보건교육',
      gotItEdu: '모든 안전보건교육 내용을 확인하고, 숙지하였습니다.'
    },
    dangerCheck: {
      dangerCheck: '위험요인 확인하기',
      TBMDanger: 'TBM 위험요인',
      dangerMange: '위험요인 및 관리방안',
      gotItDanger: '모든 위험요인과 관리방안을 확인하고, 숙지하였습니다'
    },
    TBM: {
      startWork: '금일 작업을 시작합니다.'
    },
    workEnd: {
      fighting: '작업을 시작했습니다.\n오늘도 안전한 하루되세요!',
      endMethhod: '아래 작업종료 방법을 선택해주세요',
      close: '닫기' 
    },
    BizHome: {
      safety: '오늘도 무사히 안전하세요!',
      todo: 'Todo.',
      todayTBM: '금일 TBM 현황',
      workerManage: '근로자 관리',
      waitSignup: '회원가입 승인 대기',
      person: '명'
    },
    todayTBM: {
      TBMStatus: 'TBM 현황',
      total: '전체',
      TBMok: 'TBM 완료',
      TBMnok: 'TBM 미완료',
      come: '미출근',
      nonCome: '미퇴근'
    },
    workerManage: {
      workerManage: '근로자 관리',
      workerList: '근로자 목록',
      OKList: '승인대기 목록'
    },
    TBMnoti: {
      TBMnoti: 'TBM 공지사항',
      searchTitle: '제목으로 검색하세요.',
      register: '등록하기',
      delete: '삭제'
    },
    TBMnotiRegist: {
      TBMnotiRegist: 'TBM 공지사항 등록',
      TBMnotiEdit: 'TBM 공지사항 수정',
      title: '제목',
      contents: '내용',
      inputContents: '내용을 입력해주세요',
      attachment: '첨부파일',
      add: '추가하기',
      bizType: '업종',
      notiStart: '공지 시작일',
      notiEnd: '공지 종료일'
    },
    button: {
      register: '등록',
      delete: '삭제',
      edit: '수정'
    },
    info: {
      inputNotiTitle: '공지 제목을 입력해주세요.',
      inputNotiCon: '공지 내용을 입력해주세요.'
    },
    loginReject: {
      loginReject: '회원가입 신청이 반려되었습니다.',
      question: '자세한 내용은 사업주에게 문의하세요.',
      rejectReason: '거절사유',
      loginEdit: '회원정보 수정',
      loginCancel: '회원가입 취소'
    },
    passChange: {
      longPassword: '비밀번호를 변경한지 오래되었습니다!',
      editPassword: '비밀번호를 재설정 하시겠습니까?',
      realarm: '60일 뒤 재알림',
      reset: '비밀번호 재설정'
    },
    passChangeD: {
      changePass: '오래된 비밀번호를 변경할게요.',
      newPass: '새 비밀번호',
      newPassCheck: '새 비밀번호 확인',
      samePass: '입력한 비밀번호가 일치합니다.',
      changeOK: '변경완료'
    },
    findID: {
      idSearch: '아이디 찾기입니다.',
      phoneNo: '휴대폰번호',
      receiveCheck: '인증번호 받기',
      check: '인증번호',
      OKcheck: '인증번호 확인',
      findID: '아이디 찾기',
      bizQuestion: '회원가입시 등록한 휴대폰번호가 변경되었다면,\n관리자에게 문의해주세요'
    },
    IDresult: {
      findID: '아이디를 찾았어요!',
      id: '아이디',
      idLogin: '찾은 아이디로 로그인하기',
      passWithid: '찾은 아이디로 비밀번호 찾기'
    },
    findPass: {
      findPass: '비밀번호 찾기입니다.'
    },
    passResult: {
      newPassword: '새로운 비밀번호로 변경할게요',
      oldPassword: '기존 비밀번호'
    },
    changePhone: {
      changePhone: '새로운 휴대폰번호로 변경할게요.'
    },
    workEndPopup: {
      wantEnd: '오늘의 작업이 종료됩니다. 정말로 오늘의 작업을 종료하시겠습니까?',
      Yes: '예',
      No: '아니오'
    },
    workRecord: {
      workRecord: '나의 작업이력',
      date: '작업일자',
      search: '검색기간',
      workTime: '근무시간',
      Company: '업체'
    }
  }

  private English = {
    Title: {
      Title: 'Smart Safety TBM'
    },
    login: {
      hello: 'WELCOME!',
      description: 'Work conveniently and safely using Smart Safety TBM now!',
      id: 'ID',
      password: 'Password',
      auto: 'Automatic login',
      login: 'Sign In',
      signup: 'New Account',
      findId: 'Find ID',
      findPassword: 'Find password'
    },
    loginWait: {
      done: 'Congratulations! You have successfully registered a new account',
      info: 'Membership registration will be completed once approved by the company',
      wait: 'Registration pending. Please contact your company.',
      ok: 'Confirm',
      loginWait: 'Waiting for new account registration',
      question: 'Please contact the employer for more detail'
    },
    signup: {
      signup: 'New Account',
      type: 'Type of member?',
      worker: 'Worker',
      partner: 'Company',
    },
    selectCompany: {
      selectCompany: 'Select company',
      search: 'Search company',
      searchCompany: 'Search company'
    },
    companyResult: {
      ceo: 'CEO',
      businessNo: 'Company registration number',
      findCompany: 'Searched company found',
      next: 'Next'
    },
    workerSignup: {
      workerSignup: 'Worker new account',
      registerInfo: 'Register information'
    },
    category: {
      id: 'ID',
      password: 'Password',
      passwordCheck: 'Confirm password',
      name: 'Name',
      phoneNumber: 'Phone number',
      nohyphen: 'no "-"',
      check: 'Certification',
      birthday: 'Date of Birth',
      nation: 'Nationality',
      select: 'Select',
      bizType: 'Business type',
      Type1: 'Manufacturing',
      Type2: 'Distribution',
      Type3: 'Service',
      jobType: 'Occupation type',
      man: 'Male',
      woman: 'Female',
      experience: 'Experience',
      adexperience: 'add experiences',
      certificate: 'Certificate',
      adcertificate: 'add certificates',
      selectFive: 'Add maximum of 5',
      agree: 'I agree with the Personal Information policy of Smart Safety TBM.',
      personalPolicy: 'Personal information policy',
      policyAgree: 'I agree with the Marketing policy of Smart Safety TBM.',
      policy: 'Marketing policy', 
      sign: 'Electronic signature',
      clickSign: 'Click to sign'
    },
    guide: {
      image: 'Select a Profile Photo',
      imageSelect: 'Select an image',
      album: 'Album',
      camera: 'Camera',
      inputID: 'Please enter your ID',
      idLeastLetters: 'ID must contain at least 3 letters/digits',
      idDouble: 'ID is duplicated',
      OKid: 'ID is available',
      inputPassword: 'Please enter your Password',
      leastLetters: 'Password must contain at least 6 digits/letters',
      checkPassword: 'Please check your password',
      incorrectPass: 'Incorrect password',
      inputName: 'Please enter your Name',
      inputPhone: 'Phone number',
      receiveCheck: 'Verification\ncode',
      OKcheck: 'Confirm',
      phoneNo: 'Incorrect phone number format',
      phoneDouble: 'Phone number duplicated',
      inputCheck: 'Enter verification code',
      sendCheck: 'Sending verification code',
      phoneCheck: 'Verify your phone',
      checked: 'Verified',
      inputBirthday: 'Enter your Date of birth',
      selectNation: 'Select your nationality',
      bizTypeSelect: 'Select the business type',
      jobTypeSelect: 'Select the occupation type',
      experiSelect: 'Enter your work experience (optional)',
      certifiSelect: 'Enter your certificates (optional)',
      plzPersonAgree: 'Please agree with the Personal Information policy',
      plzPolicyAgree: 'Please agree with the Marketing policy',
      plzSign: 'Please sign',
      okSign: 'New Account'
    },
    BizSignup: {
      BizSignup: 'New Account for Business',
      position: 'Job Position',
      inputPosition: 'Enter your job position (20 letters)'
    },
    toastPopup: {
      okSignup: 'New account registered',
      didSignup: 'You have been successfully registered'
    },
    loading: {
      hello1: 'Welcome',
      sir: '!',
      nicemeet: 'Nice to meet you'
    },
    workerHome: {
      startTBM: "Please begin today's TBM work",
      menu: 'Menu',
      workHistory: 'Work history',
      appNoti: 'App Notifications',
      Ealam: 'Emergency Notification',
      TBMNoti: 'TBM Notifications'
    },
    logout: {
      wantLogout: 'Log out?',
      cancel: 'Cancel',
      logout: 'Log out'
    },
    nfc: {
      nfc: 'Scan NFC',
      doNfcTag: 'Scan NFC card close to the device'
    },
    qr: {
      doQR: 'Scan QR code',
      qr: 'Scan QR'
    },
    tagPopup: {
      startWork: "Start today's work"
    },
    aftertagging: {
      TBMList: "Today's TBM Checklist",
      workBegin: 'Once everything is checked, the work will begin',
      notiCheck: 'Check notifications',
      eduCheck: 'Check Safety and Health Education',
      dangerCheck: 'Check Hazard Assessment'
    },
    noticheck: {
      TBMNotiCheck: 'Check TBM notifications',
      title: 'Title',
      writer: 'Reporter',
      contents: 'Contents',
      attachment: 'Attachment',
      next: 'Next',
      gotItNoti: 'I have read and understood all notifications',
      doSign: 'Signature'
    },
    educationCheck: {
      educationCheck: 'Check Safety and Health Education',
      TBMedu: 'TBM Safety and Health Education',
      gotItEdu: 'I have read and understood all Safety and Health Education'
    },
    dangerCheck: {
      dangerCheck: 'Check Hazard Assessment',
      TBMDanger: 'TBM Hazard Assessment',
      dangerMange: 'Hazard Assessment and Management plans',
      gotItDanger: 'I have read and understood all Hazard Assessment and management plans'
    },
    TBM: {
      startWork: "Begin today's work"
    },
    workEnd: {
      fighting: 'Have a nice day!',
      endMethhod: 'To finish a task,\nplease select a method of completion',
      close: 'Close' 
    },
    BizHome: {
      safety: 'Stay safe today!',
      todo: 'To-do list',
      todayTBM: "Today's TBM status",
      workerManage: 'Worker management',
      waitSignup: 'Waiting for new account approval',
      person: 'person'
    },
    todayTBM: {
      TBMStatus: 'TBM status',
      total: 'Total',
      TBMok: 'TBM Completed',
      TBMnok: 'TBM Incomplete',
      come: 'non attendance',
      nonCome: 'none'
    },
    workerManage: {
      workerManage: 'Manage worker',
      workerList: 'List of workers',
      OKList: 'Pending approval list'
    },
    TBMnoti: {
      TBMnoti: 'TBM Notifications',
      searchTitle: 'Search the Title',
      register: 'Register',
      delete: 'Delete'
    },
    TBMnotiRegist: {
      TBMnotiRegist: 'Register TBM Notification',
      TBMnotiEdit: 'Edit TBM Notification',
      title: 'Title',
      contents: 'Contents',
      inputContents: 'Enter the information',
      attachment: 'Attachment',
      add: 'Add more',
      bizType: 'Business type',
      notiStart: 'Announcement Start date',
      notiEnd: 'Announcement Finish date'
    },
    button: {
      register: 'Register',
      delete: 'Delete',
      edit: 'Edit'
    },
    info: {
      inputNotiTitle: 'Enter the Title for the announcement',
      inputNotiCon: 'Enter the Contents for the announcement'
    },
    loginReject: {
      loginReject: 'The new account registration approval has been rejected',
      question: 'Please contact the employer for more detail',
      rejectReason: 'Reason for rejection',
      loginEdit: 'Edit personal information',
      loginCancel: 'Cancel new account registration'
    },
    passChange: {
      longPassword: "It's been a while since you changed your password!",
      editPassword: 'Reset your password?',
      realarm: 'Remind again in 60 days',
      reset: 'Password reset'
    },
    passChangeD: {
      changePass: 'Change old password',
      newPass: 'New password',
      newPassCheck: 'Confirm new password',
      samePass: 'Password matched',
      changeOK: 'Update completed'
    },
    findID: {
      idSearch: 'Search ID',
      phoneNo: 'Phone number',
      receiveCheck: 'Receive verification code',
      check: 'Verification code',
      OKcheck: 'Confirm verification code',
      findID: 'Find ID',
      bizQuestion: 'If your phone number has changed,\nthen please contact the manager'
    },
    IDresult: {
      findID: 'Found ID!',
      id: 'ID',
      idLogin: 'Log in using the found ID',
      passWithid: 'Find my password using the found ID'
    },
    findPass: {
      findPass: 'Find password!'
    },
    passResult: {
      newPassword: 'Update password',
      oldPassword: 'Previous password'
    },
    changePhone: {
      changePhone: 'Update new phone number'
    },
    workEndPopup: {
      wantEnd: "Today's work will be completed. Would you really like to complete today's work?",
      Yes: 'Yes',
      No: 'No'
    },
    workRecord: {
      workRecord: 'My work history',
      date: 'Date of Work',
      search: 'Search period',
      workTime: 'Work hours',
      Company: 'Company'
    }
  }

  private Vietnamese = {
    Title: {
      Title: 'TBM an toàn - thông minh'
    },
    login: {
      hello: 'Rất hân hạnh chào đón bạn',
      description: 'Từ hôm nay Chúc bạn làm việc một cách an toàn và tiện lợi với TBM an toàn - Thông minh nhé!',
      id: 'ID',
      password: 'Mật khẩu',
      auto: 'Tự động đăng nhập',
      login: 'Đăng nhập',
      signup: 'Gia nhập thành viên',
      findId: 'Tìm kiếm ID',
      findPassword: 'Tìm kiếm mật khẩu'
    },
    loginWait: {
      done: 'Đã hoàn tất đăng ký gia nhập thành viên!',
      info: 'Nếu chủ doanh nghiệp chấp thuận thì việc gia nhập thành viên được hoàn tất.',
      wait: 'Đơn đăng ký thành viên đang chờ xử lý. Vui lòng liên hệ với chủ doanh nghiệp để biết thêm nội dung chi tiết.',
      ok: 'Xác nhận',
      loginWait: 'Đăng ký thành viên đang chờ xử lý',
      question: 'Vui lòng liên hệ với chủ doanh nghiệp để biết thêm thông tin chi tiết.'
    },
    signup: {
      signup: 'Gia nhập thành viên',
      type: 'Bạn đang gia nhập thành viên nào?',
      worker: 'Người lao động',
      partner: 'Chủ doanh nghiệp',
    },
    selectCompany: {
      selectCompany: 'Xin vui lòng lựa chọn doanh nghiệp',
      search: 'Tìm kiếm doanh nghiệp',
      searchCompany: 'Vui lòng tìm kiếm doanh nghiệp'
    },
    companyResult: {
      ceo: 'Đại diện',
      businessNo: 'Số đăng ký chủ doanh nghiệp',
      findCompany: 'Đã tìm thấy doanh nghiệp bạn tìm kiếm',
      next: 'Tiếp theo'
    },
    workerSignup: {
      workerSignup: 'Gia nhập thành viên người lao động',
      registerInfo: 'Vui lòng đăng nhập thông tin của bạn'
    },
    category: {
      id: 'ID',
      password: 'Mật khẩu',
      passwordCheck: 'Xác nhận mật khẩu',
      name: 'Tên',
      phoneNumber: 'Số điện thoại di động',
      nohyphen: 'nếu có -',
      check: 'Chấp nhận',
      birthday: 'Ngày tháng năm sinh',
      nation: 'Quốc tịch',
      select: 'Lựa chọn',
      bizType: 'Ngành nghề',
      Type1: 'sản xuất',
      Type2: 'Vận tải',
      Type3: 'Dịch vụ',
      jobType: 'Loại nghề nghiệp',
      man: 'Nam',
      woman: 'Nữ',
      experience: 'Kinh nghiệm nghề nghiệp',
      adexperience: 'thêm kinh nghiệm',
      certificate: 'Bằng cấp',
      adcertificate: 'thêm bằng cấp',
      selectFive: 'Có thể thêm cao nhất 5 cái',
      agree: 'Tôi đồng ý với chính sách bảo mật thông tin cá nhân của TBM An toàn - Thông minh..',
      personalPolicy: 'Chính sách bảo mật thông tin cá nhân',
      policyAgree: 'Tôi đồng ý với chính sách bảo mật Marketing của TBM An toàn - Thông minh.',
      policy: 'Chính sách bảo mật Marketing', 
      sign: 'Chữ ký điện tử',
      clickSign: 'Vui lòng bấm vào để ký.'
    },
    guide: {
      image: 'Vui lòng chọn một hình ảnh đại diện',
      imageSelect: 'Lựa chọn ảnh',
      album: 'Album',
      camera: 'Camera',
      inputID: 'Vui lòng nhập ID',
      idLeastLetters: 'Vui lòng gõ ID với ít nhất 3 ký tự.',
      idDouble: 'ID đã bị trùng lặp',
      OKid: 'Có thể sử dụng ID này',
      inputPassword: 'Vui lòng nhập mật khẩu',
      leastLetters: 'Vui lòng nhập mật khẩu với ít nhất 6 ký tự.',
      checkPassword: 'Vui lòng xác nhận mật khẩu',
      incorrectPass: 'Mật khẩu đã nhập không khớp',
      inputName: 'Vui lòng nhập tên',
      inputPhone: 'Vui lòng nhập số điện thoại',
      receiveCheck: 'Mã xác\nnhận',
      OKcheck: 'Xác nhận',
      phoneNo: 'Định dạng số điện thoại không khả dụng',
      phoneDouble: 'Số điện thoại bị trùng lặp',
      inputCheck: 'Vui lòng nhập mã xác nhận',
      sendCheck: 'Mã xác nhận đang được gửi',
      phoneCheck: 'Vui lòng xác nhận điện thoại',
      checked: 'Đã xác nhận xong',
      inputBirthday: 'Vui lòng nhập ngày tháng năm sinh',
      selectNation: 'Vui lòng lựa chọn quốc tịch',
      bizTypeSelect: 'Vui lòng lựa chọn ngành nghề',
      jobTypeSelect: 'Vui lòng chọn nghề nghiệp',
      experiSelect: 'Vui lòng nhập kinh nghiệm làm việc của bạn (tùy chọn)',
      certifiSelect: 'Vui lòng thêm bằng cấp (tùy chọn)',
      plzPersonAgree: 'Vui lòng đồng ý với chính sách bảo mật thông tin cá nhân',
      plzPolicyAgree: 'Vui lòng đồng ý với chính sách bảo mật Marketing',
      plzSign: 'Vui lòng ký tên',
      okSign: 'Gia nhập thành viên'
    },
    BizSignup: {
      BizSignup: 'Gia nhập thành viên chủ doanh nghiệp',
      position: 'Chức vụ',
      inputPosition: 'Vui lòng nhập chức vụ (20 ký tự)'
    },
    toastPopup: {
      okSignup: 'Hoàn tất gia nhập thành viên',
      didSignup: 'Đã được gia nhập thành viên'
    },
    loading: {
      hello1: 'Xin chào',
      sir: 'quý ngài',
      nicemeet: 'Rất hân hạnh chào đón bạn'
    },
    workerHome: {
      startTBM: 'Hãy bắt đầu làm việc với TBM ngay hôm nay',
      menu: 'Menu',
      workHistory: 'Lịch sử công việc',
      appNoti: 'Thông báo App',
      Ealam: 'Thông báo khẩn cấp',
      TBMNoti: 'Thông báo TBM'
    },
    logout: {
      wantLogout: 'Bạn có chắc chắn bạn muốn đăng xuất?',
      cancel: 'Hủy',
      logout: 'Đăng xuất'
    },
    nfc: {
      nfc: 'Quét NFC',
      doNfcTag: 'Vui lòng để thẻ NFC ở gần'
    },
    qr: {
      doQR: 'Vui lòng quét mã QR',
      qr: 'Quét QR'
    },
    tagPopup: {
      startWork: 'Bắt đầu làm việc ngay ngày hôm nay'
    },
    aftertagging: {
      TBMList: 'Mục lục kiểm tra TBM của ngày hôm nay.',
      workBegin: 'Sau khi kiểm tra mọi thứ, bắt đầu làm việc',
      notiCheck: 'Kiểm tra thông báo',
      eduCheck: 'Kiểm tra giáo dục an toàn sức khỏe',
      dangerCheck: 'Kiểm tra yếu tố rủi ro'
    },
    noticheck: {
      TBMNotiCheck: 'Kiểm tra thông báo TBM',
      title: 'Đề mục',
      writer: 'Người viết',
      contents: 'Nội dung',
      attachment: 'File đính kèm',
      next: 'Tiếp theo',
      gotItNoti: 'Tôi đã đọc và hiểu tất cả các thông báo',
      doSign: 'Ký tên'
    },
    educationCheck: {
      educationCheck: 'Kiểm tra giáo dục an toàn sức khỏe',
      TBMedu: 'Giáo dục an toàn sức khỏe TBM',
      gotItEdu: 'Tôi đã kiểm tra và hiểu rõ tất cả các nội dung giáo dục về an toàn và sức khỏe.'
    },
    dangerCheck: {
      dangerCheck: 'Kiểm tra yếu tố rủi ro',
      TBMDanger: 'Yếu tố rủi ro TBM',
      dangerMange: 'Các yếu tố rủi ro và phương án quản lý',
      gotItDanger: 'Tôi đã kiểm tra và hiểu rõ tất cả các yếu tố rủi ro và phương án quản lý'
    },
    TBM: {
      startWork: 'Bắt đầu làm việc ngay ngày hôm nay'
    },
    workEnd: {
      fighting: 'Chúc một ngày tốt lành!',
      endMethhod: 'Nếu muốn kết thúc công việc\nvui lòng lựa chọn cách kết thúc',
      close: 'Đóng' 
    },
    BizHome: {
      safety: 'Hôm nay chúc bạn làm việc an toàn!',
      todo: 'Những việc cần làm',
      todayTBM: 'Tình trạng TBM hôm nay',
      workerManage: 'Quản lý người lao dộng',
      waitSignup: 'Đang chờ phê duyệt thành viên',
      person: 'người'
    },
    todayTBM: {
      TBMStatus: 'Tình trạng TBM',
      total: 'Tấ cả',
      TBMok: 'Hoàn tất TBM',
      TBMnok: 'Chưa hoàn tất TBM',
      come: 'không đi làm',
      nonCome: 'Không về nhà'
    },
    workerManage: {
      workerManage: 'Quản lý người lao dộng',
      workerList: 'Danh sách người lao động',
      OKList: 'Danh sách chờ phê duyệt'
    },
    TBMnoti: {
      TBMnoti: 'Thông báo TBM',
      searchTitle: 'Vui lòng tìm kiếm bằng đề mục',
      register: 'Đăng nhập',
      delete: 'Xóa'
    },
    TBMnotiRegist: {
      TBMnotiRegist: 'Đăng nhập thông báo TBM',
      TBMnotiEdit: 'Sửa đổi thông báo TBM',
      title: 'Đề mục',
      contents: 'Nội dung',
      inputContents: 'Vui lòng nhập nội dung',
      attachment: 'File đính kèm',
      add: 'Thêm',
      bizType: 'Ngành nghề',
      notiStart: 'Ngày bắt đầu thông báo',
      notiEnd: 'Ngày kết thúc thông báo'
    },
    button: {
      register: 'Đăng nhập',
      delete: 'Xóa',
      edit: 'Sửa đổi'
    },
    info: {
      inputNotiTitle: 'Vui lòng nhập đề mục thông báo',
      inputNotiCon: 'Vui lòng nhập nội dung thông báo'
    },
    loginReject: {
      loginReject: 'Đơn đăng ký thành viên của bạn đã bị từ chối',
      question: 'Vui lòng liên hệ với chủ doanh nghiệp để biết thêm thông tin chi tiết.',
      rejectReason: 'Lý do từ chối',
      loginEdit: 'Sửa đổi thông tin thành viên',
      loginCancel: 'Hủy gia nhập thành viên'
    },
    passChange: {
      longPassword: 'Đã lâu rồi bạn không thay đổi mật khẩu của mình!',
      editPassword: 'Bạn có muốn đặt lại mật khẩu của mình không?',
      realarm: 'Nhắc nhở sau 60 ngày',
      reset: 'Đặt lại mật khẩu'
    },
    passChangeD: {
      changePass: 'Sẽ thay đổi mật khẩu cũ.',
      newPass: 'Mật khẩu mới',
      newPassCheck: 'Xác nhận mật khẩu mới',
      samePass: 'Mật khẩu bạn nhập đã phù hợp',
      changeOK: 'Hoàn tất thay đổi'
    },
    findID: {
      idSearch: 'Tìm kiếm ID',
      phoneNo: 'Số điện thoại',
      receiveCheck: 'Nhận mã xác nhận',
      check: 'Mã xác nhận',
      OKcheck: 'Kiểm tra mã xác nhận',
      findID: 'Tìm kiếm ID',
      bizQuestion: 'Nếu số điện thoại đăng ký thành viên đã thay đổi,\nvui lòng liên hệ với người quản lý'
    },
    IDresult: {
      findID: 'Đã tìm thấy ID',
      id: 'ID',
      idLogin: 'Đăng nhập bằng ID đã tìm thấy',
      passWithid: 'Tìm kiếm mật khẩu bằng ID đã tìm thấy'
    },
    findPass: {
      findPass: 'Tìm kiếm mật khẩu'
    },
    passResult: {
      newPassword: 'Sẽ thay đổi bằng mật khẩu mới',
      oldPassword: 'Mật khẩu có sẵn'
    },
    changePhone: {
      changePhone: 'Sẽ thay đổi bằng số điện thoại mới'
    },
    workEndPopup: {
      wantEnd: 'Công việc hôm nay được hoàn tất. Bạn có chắc chắn muốn kết thúc nhiệm vụ hôm nay không?',
      Yes: 'Có',
      No: 'Không'
    },
    workRecord: {
      workRecord: 'Lịch sử làm việc của tôi',
      date: 'Ngày làm việc',
      search: 'Thời gian tìm kiếm',
      workTime: 'Thời gian làm việc',
      Company: 'Doanh nghiệp'
    }
  }

  private Thai = {
    Title: {
      Title: 'ความปลอดภัยดีเยี่ยม TBM'
    },
    login: {
      hello: 'ยินดีที่ได้รู้จักค่ะ',
      description: 'ในอนาคต ขอให้ทำงานอย่างสะดวกและปลอดภัยที่ ความปลอดภัยสมาร์ต TBM !',
      id: 'ID',
      password: 'รหัสผ่าน',
      auto: 'ล็อคอัตโนมัติ',
      login: 'ล็อคอิน',
      signup: 'การสมัครสมาชิก',
      findId: 'การค้นหา ID',
      findPassword: 'การค้นหารหัสผ่าน'
    },
    loginWait: {
      done: 'การสมัครสมาชิกสมบูรณ์ค่ะ!',
      info: 'ถ้าเจ้าของธุรกิจอนุมัติการสมัครสมาชิกก็สมบูรณ์ค่ะ',
      wait: 'การสมัครสมาชิกกำลังดำเนินการอยู่ ช่วยสอบถามเนื้อหาอย่างละเอียดกับเจ้าของกิจการ',
      ok: 'ตรวจสอบ',
      loginWait: 'กำลังดำเนินการสมัครสมาชิกค่ะ',
      question: 'กรุณาสอบถามรายละเอียดกับเจ้าของกิจการ'
    },
    signup: {
      signup: 'การสมัครสมาชิก',
      type: 'ต้องการสมัครสมาชิกแบบไหนคะ?',
      worker: 'ผู้ใช้แรงงาน',
      partner: 'เจ้าของกิจการ',
    },
    selectCompany: {
      selectCompany: 'กรุณาเลือกบริษัท',
      search: 'การค้นหาบริษัท',
      searchCompany: 'กรุณาค้นหาบริษัท'
    },
    companyResult: {
      ceo: 'ตัวแทน',
      businessNo: 'เลขจดทะเบียนเจ้าของนักลงทุน(นักธุรกิจ)',
      findCompany: 'ค้นพบบริษัทที่ค้นหาแล้วค่ะ',
      next: 'ต่อไป'
    },
    workerSignup: {
      workerSignup: 'การสมัครสมาชิกผู้ใช้แรงงาน (คนงาน ผู้ใช้งาน)',
      registerInfo: 'กรุณาลงทะเบียนข้อมูล'
    },
    category: {
      id: 'ID',
      password: 'รหัสผ่าน',
      passwordCheck: 'ตรวจสอบรหัสลับ',
      name: 'ชื่อ',
      phoneNumber: 'เบอร์โทรศัพท์',
      nohyphen: 'no "-"',
      check: 'การยืนยัน',
      birthday: 'วันเดือนปีเกิด',
      nation: 'สัญชาติ',
      select: 'เลือก',
      bizType: 'ประเภทอาชีพ',
      Type1: 'การผลิต',
      Type2: 'โลจิสติกส์',
      Type3: 'การบริการ',
      jobType: 'อาชีพ',
      man: 'ชาย',
      woman: 'หญิง',
      experience: 'ประวัติส่วนตัว',
      adexperience: 'ประวัติส่วนตัวเพิ่มเติม',
      certificate: 'ใบรับรอง',
      adcertificate: 'ใบรับรองเพิ่มเติม',
      selectFive: 'สามารถเพิ่มได้สูงสุด 5 รายการ',
      agree: 'ฉันยอมรับนโยบายความเป็นส่วนตัว ความปลอดภัยดีเยี่ยมของ TBM',
      personalPolicy: 'นโยบายความเป็นส่วนตัว',
      policyAgree: 'ฉันยอมรับนโยบายการตลาด ความปลอดภัยดีเยี่ยมของ TMB',
      policy: 'นโยบายการตลาด', 
      sign: 'ลายเซ็นดิจิทัล',
      clickSign: 'กรุณากดปุ่มคลิกและเซ็นชื่อค่ะ'
    },
    guide: {
      image: 'กรุณาเลือกรูปโปรไฟล์ค่ะ',
      imageSelect: 'เลือกรูป',
      album: 'อัลบั้ม',
      camera: 'กล้อง',
      inputID: 'กรุณาป้อน ID',
      idLeastLetters: 'กรุณาสร้าง ID 3ตัว(อักษร)ขึ้นไปค่ะ',
      idDouble: 'ID ซ้ำกันค่ะ',
      OKid: 'เป็น ID ที่ใช้ได้ค่ะ',
      inputPassword: 'กรุณาใส่รหัสผ่านค่ะ',
      leastLetters: 'กรุณาใส่ รหัสผ่าน 3ตัว(อักษร)ขึ้นไปค่ะ',
      checkPassword: 'กรุณาใส่รหัสผ่านยืนยันค่ะ',
      incorrectPass: 'รหัสผ่านที่ใส่ไว้ไม่ตรงกันค่ะ',
      inputName: 'กรุณาใส่ชื่อค่ะ',
      inputPhone: 'กรุณาใส่เลขเบอร์โทรศัพท์ค่ะ',
      receiveCheck: 'หมายเลขยืนยัน',
      OKcheck: 'ตรวจสอบ',
      phoneNo: 'เป็นหมายเลข(เบอร์โทร)ที่ไม่สามารถใช้ได้ (ติดต่อไม่ได้)',
      phoneDouble: 'หมายเลขโทรศัพท์มือถือซ้ำกันค่ะ',
      inputCheck: 'กรุณาใส่หมายเลขยืนยันค่ะ',
      sendCheck: 'กำลังส่งหมายเลขยืนยันค่ะ',
      phoneCheck: 'กรุณายืนยันที่โทรศัพท์มือถือ',
      checked: 'ยืนยันแล้วค่ะ',
      inputBirthday: 'กรุณาใสวันเดือนปีเกิดค่ะ',
      selectNation: 'กรุณาเลือกสัญชาติค่ะ',
      bizTypeSelect: 'กรุณาเลือกอาชีพค่ะ',
      jobTypeSelect: 'กรุณาเลือกประเภทของอาชีพ',
      experiSelect: 'กรุณาใส่ประวัติส่วนตัว (ประสบการณ์การทำงาน)ค่ะ (กรณีเลือก / ตัวเลือก)',
      certifiSelect: 'กรุณาเพิ่มใบรับรอง(ใบประกาศนียบัตร)ค่ะ (กรณีเลือก / ตัวเลือก)',
      plzPersonAgree: 'กรุณายอมรับนโยบายความเป็นส่วนตัวค่ะ',
      plzPolicyAgree: 'กรุณายอมรับนโยบายการตลาดค่ะ',
      plzSign: 'กรุณาเซ็นชื่อค่ะ',
      okSign: 'สมัครสมาชิก'
    },
    BizSignup: {
      BizSignup: 'สมัครสมาชิกสำหรับเจ้าของกิจการ',
      position: 'ตำแหน่งงาน',
      inputPosition: 'กรุณาใส่ตำแหน่งงาน (20 ตัว)'
    },
    toastPopup: {
      okSignup: 'สมัครสมาชิกสมบูรณ์',
      didSignup: 'สมัครสมาชิกแล้วค่ะ'
    },
    loading: {
      hello1: 'สวัสดีค่ะ',
      sir: 'ท่าน',
      nicemeet: 'ยินดีต้อนรับค่ะ ยินดีด้วยค่ะ'
    },
    workerHome: {
      startTBM: 'เริ่มทำงาน TMB วันนี้ได้เลยนะคะ',
      menu: 'รายการ',
      workHistory: 'ประวัติงาน',
      appNoti: 'APP การประกาศ',
      Ealam: 'แจ้งเหตุฉุกเฉิน',
      TBMNoti: 'ประกาศ TMB'
    },
    logout: {
      wantLogout: 'จะทำการล็อคเอ้าท์',
      cancel: 'ยกเลิก',
      logout: 'ล็อคเอ้าท์'
    },
    nfc: {
      nfc: 'สแกน NFC',
      doNfcTag: 'กรุณาแท็กใกล้กับคาร์ด NFC'
    },
    qr: {
      doQR: 'กรุณาสแกน QR โค้ด',
      qr: 'สแกน QR'
    },
    tagPopup: {
      startWork: 'เริ่มงานวันนี้'
    },
    aftertagging: {
      TBMList: 'รายการตรวจสอบ TMB วันนี้',
      workBegin: 'หลังตรวจสอบทั้งหมดแล้วเริ่มงานได้ค่ะ',
      notiCheck: 'การตวจสอบการประกาศ',
      eduCheck: 'การตรวจสอบสุขอนามัยความปลอดภัย',
      dangerCheck: 'การตรวจสอบปัจจัยอันตราย'
    },
    noticheck: {
      TBMNotiCheck: 'การตรวจสอบการประกาศ TMB',
      title: 'หัวข้อ',
      writer: 'ผู้เขียน',
      contents: 'เนื้อหา',
      attachment: 'เอกสารแนบ',
      next: 'ต่อไป',
      gotItNoti: 'ได้อ่าน(ตรวจสอบ)และเข้าใจประกาศทั้งหมดแล้ว',
      doSign: 'เซ็นชื่อ'
    },
    educationCheck: {
      educationCheck: 'การตรวจสอบสุขอนามัยความปลอดภัย',
      TBMedu: 'สุขอนามัยความปลอดภัย TMB',
      gotItEdu: 'ได้ตรวจสอบและเข้าใจเนื้อหาสุขอนามัยความปลอดภัยทั้งหมดแล้ว'
    },
    dangerCheck: {
      dangerCheck: 'การตรวจสอบปัยจัยอันตราย',
      TBMDanger: 'ปัจจัยอันตรายของ TMB',
      dangerMange: 'ปัจจัยอันตราย และ แผนการจัดการ',
      gotItDanger: 'ได้ตรวจสอบและเข้าใจปัจจัยอันตรายและแผนการจัดการแล้ว'
    },
    TBM: {
      startWork: 'เริ่มการทำงานวันนี้'
    },
    workEnd: {
      fighting: 'วันนี้ก็สู้ๆนะคะ',
      endMethhod: 'ถ้าต้องการทำรายการให้สำเร็จกรุณาเ\nลือกวิธีการทำรายการ',
      close: 'ปิด' 
    },
    BizHome: {
      safety: 'วันนี้ก็ขอให้ปลอดภัยนะคะ!',
      todo: 'To-do list',
      todayTBM: 'สถานการณ์ TMB ระยะนี้',
      workerManage: 'การจัดการ (คนงาน ผู้ใช้แรงงาน ผู้ใช้งาน)',
      waitSignup: 'กำลังรอการอนุมัติสมัครสมาชิก',
      person: 'คน'
    },
    todayTBM: {
      TBMStatus: 'สถานการณ์ปัจจุบัน TMB',
      total: 'ทั้งหมด',
      TBMok: 'TMB สำเร็จ',
      TBMnok: 'TMB ไม่สำเร็จ',
      come: 'ไม่มีงานทำ',
      nonCome: 'ไม่มีเลิกงาน'
    },
    workerManage: {
      workerManage: 'การจัดการ (คนงาน)',
      workerList: 'รายการ ผู้ใช้แรงงาน',
      OKList: 'รายการรออนุมัติ'
    },
    TBMnoti: {
      TBMnoti: 'การประกาศ TMB',
      searchTitle: 'กรุณาตรวจสอบด้วยหัวข้อ',
      register: 'การลงทะเบียน',
      delete: 'การลบออก'
    },
    TBMnotiRegist: {
      TBMnotiRegist: 'ประกาศการลงทะเบียน TMB',
      TBMnotiEdit: 'แก้ไขประกาศ TMB',
      title: 'หัวข้อ',
      contents: 'เนื้อหา',
      inputContents: 'กรุณากรอกเนื้อหา',
      attachment: 'เอกสารแนบ',
      add: 'การเพิ่มเติม',
      bizType: 'ประเภทอาชีพ',
      notiStart: 'วันเริ่มประกาศ',
      notiEnd: 'วันสิ้นสุดการประกาศ'
    },
    button: {
      register: 'ลงทะเบียน',
      delete: 'การลบออก',
      edit: 'การแก้ไข'
    },
    info: {
      inputNotiTitle: 'กรุณาใส่หัวข้อการประกาศ',
      inputNotiCon: 'กรุณาใส่เนื้อหาการประกาศ'
    },
    loginReject: {
      loginReject: 'การสมัครสมาชิกถูกปฏิเสธค่ะ',
      question: 'กรุณาสอบถามรายละเอียดกับเจ้าของกิจการ',
      rejectReason: 'เหตุผลในการปฏิเสธ',
      loginEdit: 'การแก้ไขข้อมูลสมาชิก',
      loginCancel: 'การยกเลิกการสมัครสมาชิก'
    },
    passChange: {
      longPassword: 'นานแล้วที่คุณเปลี่ยนรหัสผ่าน!',
      editPassword: 'ต้องการรีเซ็ตรหัสผ่านไหมคะ?',
      realarm: 'เตือนความจำหลัง 60วัน',
      reset: 'รีเซ็ตรหัสผ่าน'
    },
    passChangeD: {
      changePass: 'จะเปลี่ยนรหัสผ่านเก่า',
      newPass: 'รหัสผ่านใหม่',
      newPassCheck: 'การตรวจสอบรหัสผ่านใหม่',
      samePass: 'รหัสตรงกับที่ป้อนไว้',
      changeOK: 'การเปลี่ยนแปลงสมบูรณ์'
    },
    findID: {
      idSearch: 'การค้นหา ID',
      phoneNo: 'เบอร์โทรศัพท์',
      receiveCheck: 'การรับหมายเลขยืนยัน',
      check: 'หมายเลขยืนยัน',
      OKcheck: 'ตรวจสอบหมายเลขยืนยัน',
      findID: 'การค้นหา ID',
      bizQuestion: 'ถ้าหากมีการเปลี่ยนแปลงเบอร์โทรที่ได้ลงทะเบียนการสมัครสมาชิก\nกรุณาสอบถามเจ้าหน้าที่'
    },
    IDresult: {
      findID: 'ค้นพบ ID แล้ว',
      id: 'ID',
      idLogin: 'การล็อคอินด้วย ID ที่ค้นพบ',
      passWithid: 'ค้นหารหัสผ่านด้วย ID ที่พบ'
    },
    findPass: {
      findPass: 'ค้นหารหัสผ่าน'
    },
    passResult: {
      newPassword: 'จะเปลี่ยนเบอร์โทรศัพท์ใหม่ค่ะ',
      oldPassword: 'รหัสเก่า(รหัสผ่านเก่า)'
    },
    changePhone: {
      changePhone: 'จะเปลี่ยนเบอร์โทรศัพท์ใหม่ค่ะ'
    },
    workEndPopup: {
      wantEnd: 'สิ้นสุดงานของวันนี้ คุณแน่ใจหรือไม่ว่าต้องการสิ้นสุดงานของวันนี้',
      Yes: 'ใช่',
      No: 'ไม่'
    },
    workRecord: {
      workRecord: 'ประวัติการทำงานของฉัน',
      date: 'วันทำงาน',
      search: 'ช่วงเวลาตรวจสอบ',
      workTime: 'เวลาทำการ',
      Company: 'บริษัท'
    }
  }

  private Chinese = {
    Title: {
      Title: '智能安全TBM'
    },
    login: {
      hello: '很高兴见到你。',
      description: '未来在 智能安全 TBM 上方便、安全地工作！',
      id: '帐户',
      password: '密码',
      auto: '自动登录',
      login: '登录',
      signup: '加入会员',
      findId: '找回账号',
      findPassword: '找回密码'
    },
    loginWait: {
      done: '申请会员已完成！',
      info: '企业主批准之后，会员注册可完成。',
      wait: '会员申请正在等待中。请联系企业主了解详情。',
      ok: '确认',
      loginWait: '等待会员注册申请。',
      question: '详细内容请咨询业主。'
    },
    signup: {
      signup: '加入会员',
      type: '注册的是哪种会员？',
      worker: '工人',
      partner: '业主',
    },
    selectCompany: {
      selectCompany: '请选择公司',
      search: '公司搜索',
      searchCompany: '请搜索公司'
    },
    companyResult: {
      ceo: '代表',
      businessNo: '经营者注册号',
      findCompany: '您搜索的公司以找到',
      next: '下一个'
    },
    workerSignup: {
      workerSignup: '工人加入会员',
      registerInfo: '请注册您的信息'
    },
    category: {
      id: '账号',
      password: '密码',
      passwordCheck: '确认密码',
      name: '姓名',
      phoneNumber: '手机号码',
      nohyphen: '不要输入 -',
      check: '认证',
      birthday: '出生日期',
      nation: '国籍',
      select: '选择',
      bizType: '业种',
      Type1: '生产',
      Type2: '分销',
      Type3: '服务',
      jobType: '职业',
      man: '男',
      woman: '女',
      experience: '职业经历',
      adexperience: '添加经历',
      certificate: '认证书',
      adcertificate: '添加认证书',
      selectFive: '最多可添加 5 个',
      agree: '我同意 智能安全 TBM 隐私政策。',
      personalPolicy: '个人隐私政策',
      policyAgree: '我同意智能安全 TBM 营销政策。',
      policy: '营销政策', 
      sign: '电子签名',
      clickSign: '请点击签名。'
    },
    guide: {
      image: '请选择个人简介图片。',
      imageSelect: '选择一张图片',
      album: '相册',
      camera: '摄像头',
      inputID: '请输入您的账号。',
      idLeastLetters: '请用至少 3 个字符写下您的账号',
      idDouble: '账号重复。',
      OKid: '用户名可用。.',
      inputPassword: '请输入密码。',
      leastLetters: '请输入至少 6 个字符的密码。',
      checkPassword: '请输入确认密码。',
      incorrectPass: '您输入的密码不匹配。',
      inputName: '请输入您的姓名',
      inputPhone: '请输入您的手机号码',
      receiveCheck: '获取验证码',
      OKcheck: '确认验证码',
      phoneNo: '电话号码格式不可用。',
      phoneDouble: '手机号码重复。',
      inputCheck: '请输入验证码',
      sendCheck: '正在发送验证码。',
      phoneCheck: '请验证您的手机号码。',
      checked: '已通过认证。',
      inputBirthday: '请输入您的出生日期。',
      selectNation: '请选择您的国籍。',
      bizTypeSelect: '请选择职业',
      jobTypeSelect: '请选择您的职业。',
      experiSelect: '请输入您的工作经历（可选）',
      certifiSelect: '请添加证书（可选）',
      plzPersonAgree: '请同意隐私政策。',
      plzPolicyAgree: '请同意营销政策。',
      plzSign: '请签名',
      okSign: '加入会员'
    },
    BizSignup: {
      BizSignup: '企业主加入会员',
      position: '职责',
      inputPosition: '请输入您的职责名称（20 个字符）'
    },
    toastPopup: {
      okSignup: '会员完成',
      didSignup: '您已注册。'
    },
    loading: {
      hello1: '你好',
      sir: '先生(女士)',
      nicemeet: '很高兴见到你。'
    },
    workerHome: {
      startTBM: '请开始今天的 TBM工作。.',
      menu: '菜单',
      workHistory: '工作经历',
      appNoti: 'APP通知',
      Ealam: '紧急通知',
      TBMNoti: 'TBM通知'
    },
    logout: {
      wantLogout: '您确定要退出吗？',
      cancel: '取消',
      logout: '退出'
    },
    nfc: {
      nfc: 'NFC扫描',
      doNfcTag: '请在附近标记 NFC 卡。'
    },
    qr: {
      doQR: '请扫描二维码。',
      qr: '二维码扫描'
    },
    tagPopup: {
      startWork: '开始今天工作。'
    },
    aftertagging: {
      TBMList: '今天的 TBM 检查表。',
      workBegin: '检查完毕后，开始工作。',
      notiCheck: '确认检查通知',
      eduCheck: '确认安全保健教育',
      dangerCheck: '确认风险因素'
    },
    noticheck: {
      TBMNotiCheck: '确认 TBM 通知',
      title: '标题',
      writer: '作家',
      contents: '内容',
      attachment: '附件',
      next: '下一个',
      gotItNoti: '我已阅读并理解所有通知。',
      doSign: '签字。'
    },
    educationCheck: {
      educationCheck: '确认安全保健教育',
      TBMedu: 'TBM安全保健教育',
      gotItEdu: '已确认和理解所有安全和保健培训内容。'
    },
    dangerCheck: {
      dangerCheck: '确认风险因素',
      TBMDanger: 'TBM危险因素',
      dangerMange: '风险因素和管理方案',
      gotItDanger: '已确认和理解所有风险因素和管理方案'
    },
    TBM: {
      startWork: '开始今天工作。'
    },
    workEnd: {
      fighting: '今天也要加油。',
      endMethhod: '如果结束操作,\n请选择退出方法。',
      close: '关闭' 
    },
    BizHome: {
      safety: '今天也要安全！',
      todo: 'To do 列表',
      todayTBM: '今天的 TBM 状态',
      workerManage: '工人管理',
      waitSignup: '等待注册会员批准',
      person: '人'
    },
    todayTBM: {
      TBMStatus: 'TBM现况',
      total: '全部',
      TBMok: '完成 TBM',
      TBMnok: '未完整 TBM',
      come: '缺勤',
      nonCome: '未下班'
    },
    workerManage: {
      workerManage: '工人管理',
      workerList: '工人名单',
      OKList: '待批目录'
    },
    TBMnoti: {
      TBMnoti: 'TBM通知',
      searchTitle: '请搜索题目。',
      register: '登记',
      delete: '删除'
    },
    TBMnotiRegist: {
      TBMnotiRegist: 'TBM登记公告',
      TBMnotiEdit: 'TBM公告事项修改',
      title: '标题',
      contents: '内容',
      inputContents: '请输入您的详细信息',
      attachment: '附件',
      add: '添加',
      bizType: '行业',
      notiStart: '通知开始日期',
      notiEnd: '通知结束日期'
    },
    button: {
      register: '注册',
      delete: '删除',
      edit: '修改'
    },
    info: {
      inputNotiTitle: '请输入通知的标题。',
      inputNotiCon: '请输入通知的内容。'
    },
    loginReject: {
      loginReject: '会员注册申请被退回。',
      question: '详细内容请咨询业主。',
      rejectReason: '拒绝理由',
      loginEdit: '修改会员信息',
      loginCancel: '取消会员注册'
    },
    passChange: {
      longPassword: '密码更改已久！',
      editPassword: '确定要重新设置密码吗？',
      realarm: '60天后再次通知',
      reset: '密码重置'
    },
    passChangeD: {
      changePass: '我要更改老密码。',
      newPass: '新密码',
      newPassCheck: '确认新密码',
      samePass: '输入的密码匹配 。',
      changeOK: '完成变更'
    },
    findID: {
      idSearch: '寻找账号',
      phoneNo: '手机号码',
      receiveCheck: '获取验证码',
      check: '验证码',
      OKcheck: '确认验证码',
      findID: '找回账号',
      bizQuestion: '注册的手机号如有变更，请咨询管理者。'
    },
    IDresult: {
      findID: '找到账号！',
      id: '账号',
      idLogin: '用已找到的账号登录',
      passWithid: '用已找到的账号找回密码'
    },
    findPass: {
      findPass: '找回密码。'
    },
    passResult: {
      newPassword: '更改密码。',
      oldPassword: '现在密码'
    },
    changePhone: {
      changePhone: '更改新的手机号。'
    },
    workEndPopup: {
      wantEnd: '今天的操作即将结束。 \n确认要退出今天的任务吗 ？',
      Yes: '例子',
      No: '否'
    },
    workRecord: {
      workRecord: '我的操作履历',
      date: '操作日期',
      search: '搜索期间',
      workTime: '工作时间',
      Company: '公司'
    }
  }


  public selected = this.Korean;

  private _type:Language = 'Korean';
  public get type() { return this._type }
  public set type(type:Language) {
    if(type !== this._type) {
      this._type = type;
      this.selected = this[type];
      window.localStorage.setItem('@language', type);
    }
  }
















  constructor() {
    const language = <Language>window.localStorage.getItem('@language');
    if(language) this.type = language;
  }
}
